import { Pipe, PipeTransform } from '@angular/core';
import { SharedService } from '../services/shared.service';

@Pipe({
  name: 'formateUrl'
})
export class FormateUrlPipe implements PipeTransform {
  /**
   *
   */
  constructor(private sharedService: SharedService) {

  }

  transform(value: any, ...args: any): any {
    if (args[0] == undefined || args[0].length == 0) {
      return value.replace(/ +/g, "-");
    }
    else {
      return value.replace(/ +/g, "-") + "/" + this.sharedService.encryptData(this.sharedService.queryStringToObject(args[0]));
    }
  }
}
